<ion-content>
  <ion-grid
    class="modal-container"
    [ngClass]="{
      'user-assignment-view-share__outher-container': !notificationConfirmation
    }"
  >
    <ion-row class="content-padding-vertical h-100" justify-content-center>
      <ion-col class="display-flex flex-direction-column">
        <app-modal-header
          header="{{ 'SPACE.PARKING.SHARE_PARKING_SPACE_HEADER' | translate }}"
          (close)="onCloseModal()"
          [hideBackButton]="notificationConfirmation"
        >
        </app-modal-header>
        <ion-grid
          class="display-flex flex-direction-column ion-justify-content-end overflow-hidden"
        >
          <ion-row>
            <ion-col size="12" *ngIf="notificationConfirmation">
              {{ "SPACE.PARKING.SHARE_PARKING_SPACE_INFO_1" | translate }}
              <strong>
                {{ assignmentDetails.space.name }}
              </strong>
              {{ "SPACE.PARKING.SHARE_PARKING_SPACE_INFO_2" | translate }}
            </ion-col>
            <ion-col size="12" *ngIf="!notificationConfirmation">
              {{ "SPACE.PARKING.SHARE_PARKING_SPACE_INFO" | translate }}
            </ion-col>
          </ion-row>
          <ion-row #buttonsContainer>
            <ion-col size="4">
              <ion-button
                (click)="onShareSpaceHours($event, 0.5)"
                class="user-assignment-view-share__hour-button"
                fill="clear"
                shape="round"
              >
                <div>30 min.</div>
              </ion-button>
            </ion-col>
            <ion-col size="4" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
              <ion-button
                (click)="onShareSpaceHours($event, i)"
                class="user-assignment-view-share__hour-button"
                fill="clear"
                shape="round"
              >
                <div>{{ i }} {{ "HOUR" | translate }}</div>
              </ion-button>
            </ion-col>
            <ion-col size="8">
              <ion-button
                (click)="onShareSpaceHours($event, 'byDayEnd')"
                class="user-assignment-view-share__hour-button"
                fill="clear"
                shape="round"
              >
                {{ "BY_DAYS_END" | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <div
                class="parking-add-reservation__date-input parking-add-reservation__date-input--first"
              >
                <ion-label
                  >{{
                    "SPACE.YOU_MAY_CHOOSE_EXACT_SHARING_START_HOUR"
                      | translate
                  }}
                </ion-label>

                <app-date-time-picker
                  pickerType="timer"
                  [value]="endDate"
                  placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                  (afterPickerClosed)="onSetEndTime($event)"
                ></app-date-time-picker>
              </div>
            </ion-col>
          </ion-row>

          <!-- PRZYCISKI POTWIERDZENIA Z NOTYFIKACJI -->
          <ion-row class="ion-margin-top" *ngIf="notificationConfirmation">
            <ion-col size="4">
              <ion-button class="w-100" (click)="onSave()" fill="outline">
                {{ "NO" | translate }}
              </ion-button>
            </ion-col>
            <ion-col size="8">
              <ion-button
                class="w-100"
                (click)="onShareSpaceNotification()"
                [disabled]="!endDate"
              >
                {{ "SPACE.FREE_UP" | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <!-- PRZYCISK OTWIERANIA SZLABANU -->
          <ion-row>
            <ion-col
              size="12"
              class="ion-margin-top"
              *ngIf="!notificationConfirmation"
            >
              <ion-button class="w-100" (click)="onShareSpaceBarierr()">
                {{ "SPACE.SHARE" | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="errorMessage">
            <ion-col size="12">
              <ion-label color="danger" class="font-size__16">{{ errorMessage }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #DialHint>
  <p class="timepicker__dial-hint">{{ "TIMEPICKER_HINT" | translate }}</p>
</ng-template>
<ng-template #cancelBtn>
  <button class="timepicker-button">{{ "CANCEL" | translate }}</button>
</ng-template>
